import type { TpaStreamAnalyticsFlowOutcome } from 'types/tpaStreamAnalytics';

export const TPA_STREAM_ANALYTICS_FLOW_SESSION_KEY = 'spence_tpa_stream_analytics_flow';

const canUseSessionStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.sessionStorage?.getItem === 'function';

export const getTpaStreamAnalyticsFlowOutcome = (): TpaStreamAnalyticsFlowOutcome | null => {
  if (!canUseSessionStorage()) {
    return null;
  }

  const raw = window.sessionStorage.getItem(TPA_STREAM_ANALYTICS_FLOW_SESSION_KEY);
  if (raw === 'started' || raw === 'completed' || raw === 'failed' || raw === 'abandoned') {
    return raw;
  }

  return null;
};

export const setTpaStreamAnalyticsFlowOutcome = (outcome: TpaStreamAnalyticsFlowOutcome): void => {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    window.sessionStorage.setItem(TPA_STREAM_ANALYTICS_FLOW_SESSION_KEY, outcome);
  } catch {
    // Quota / private mode — analytics may still POST without flow tracking.
  }
};

export const clearTpaStreamAnalyticsFlowOutcome = (): void => {
  if (!canUseSessionStorage() || typeof window.sessionStorage.removeItem !== 'function') {
    return;
  }

  window.sessionStorage.removeItem(TPA_STREAM_ANALYTICS_FLOW_SESSION_KEY);
};

export const shouldEmitTpaStreamConnectionAbandoned = (): boolean =>
  getTpaStreamAnalyticsFlowOutcome() === 'started';
